import Vue from 'vue'

function Speech () {

  let recognition = null
  let prepareRestart = false
  let checkedSupport = false
  let data = {
    support: false,
    running: false,
    language: navigator.language || navigator.userLanguage
  }

  let SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
  if(SpeechRecognition){
    recognition = new SpeechRecognition()

    recognition.continuous = true;
    recognition.interimResults = false;

    recognition.onstart = onStartCheckSupport
    /*recognition.onresult = onResult
    recognition.onend = onEnd
    recognition.onsoundend = onSoundEnd
    recognition.onaudioend = onSoundEnd*/

  }

  function onStartCheckSupport() {
    recognition.stop();
    data.support = true;
    recognition = new SpeechRecognition()

    recognition.onstart = onStart
    recognition.onresult = onResult
    recognition.onend = onEnd
    recognition.onsoundend = onSoundEnd
    recognition.onaudioend = onSoundEnd
  }

  function onStart() {
    data.running = true
  }

  function onResult(event) {
    let length = event.results.length
    let r = event.results[length-1]
    if(r.isFinal){
      Vue.prototype.$eventBus.$emit('speech: result', r[0].transcript)
    }
  }

  function onEnd(){
    if(data.running && prepareRestart){
      start();
    }
    else{
      data.running = false
    }
    prepareRestart = false
  }

  function onSoundEnd() {
    prepareRestart = true
  }

  function checkSupport() {
    if(!checkedSupport && recognition){
      checkedSupport = true
      recognition.start();

    }
  }

  function start() {
    if(recognition){
      recognition.start();
    }
  }

  function stop() {
    if(recognition){
      data.running = false
      recognition.stop();
    }
  }

  function restart() {
    if(recognition){
      recognition.stop();
    }
  }

  function setLanguage(language) {
    recognition.lang = language
    data.language = language
    restart();
  }

  return {
    data: data,
    checkSupport: checkSupport,
    start: start,
    stop: stop,
    setLanguage: setLanguage
  }
}

export {
  Speech
}
